// extracted by mini-css-extract-plugin
export default {"candidateTable":"styles_candidateTable__eCy0E","customBox":"styles_customBox__IwUlw","contentBox":"styles_contentBox__Le-nk","headingBox":"styles_headingBox__tRp2K"};